import angular from "angular";

function dataBrokerService ($q) {
    return {
        getItem
    };

    function getItem (key) {
        return $q((resolve, reject)=> {
            let item = window[key];

            if (item === undefined){
                reject(`dataBroker.service: Cannot find item for given key: ${key}`);
            } else {
                resolve(item);
            }
        });
    }
}

dataBrokerService.$inject = [ '$q' ];


export default angular.module('cars.dataBroker', [])
    .config([() => {}])
    .service('dataBrokerService', dataBrokerService)
    .name;

